import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../../services/api";
import { FaCog } from "react-icons/fa";

export const SetupProgressHeader: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [progress, setProgress] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const isWizardPage = location.pathname === "/admin/setup-wizard";

  useEffect(() => {
    if (!isWizardPage) {
      fetchProgress();
    }
  }, [isWizardPage]);

  const fetchProgress = async () => {
    try {
      setLoading(true);
      const response = await api.get("/store/setup-progress");
      setProgress(response.data);
    } catch (err: any) {
      console.error("Failed to fetch progress:", err);
    } finally {
      setLoading(false);
    }
  };

  if (isWizardPage || loading || !progress) {
    return null;
  }

  const overallProgress = progress.overallProgress || 0;

  // Don't show if 100% complete
  if (overallProgress >= 100) {
    return null;
  }

  return (
    <button
      onClick={() => navigate("/admin/setup-wizard")}
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      title={t("admin.setupProgress.openWizard")}
    >
      <div className="relative w-8 h-8">
        <svg className="w-8 h-8 transform -rotate-90">
          <circle
            cx="16"
            cy="16"
            r="14"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            className="text-gray-200"
          />
          <circle
            cx="16"
            cy="16"
            r="14"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeDasharray={`${2 * Math.PI * 14}`}
            strokeDashoffset={`${2 * Math.PI * 14 * (1 - overallProgress / 100)}`}
            className="text-blue-600 transition-all duration-300"
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-bold text-gray-700">{overallProgress}%</span>
        </div>
      </div>
      <div className="hidden md:block text-sm">
        <div className="font-medium text-gray-900">
          {progress.completedItems} / {progress.totalItems}
        </div>
      </div>
      <FaCog className="text-gray-600" />
    </button>
  );
};

